// extracted by css-extract-rspack-plugin
export default {"spinnerContainer":"_8c17c7a3","fade":"_abe2943f","spinner":"_2ddb5264"};